/**
 * @param allPosts
 * @returns {JSX.Element}
 * @constructor
 */
import Layout from "../../components/layout/layout";
import Head from "next/head";
import Container from "../../components/Container";
import Block from "../../components/Block";
import NavBar from "../../components/navbar/NavBar";
import {DynamicSection} from "../../components/common/DynamicSection";
import MainTitle from "../../components/product-details/MainTitle";
import useRouterScroll from "../../components/common/useRouterScroll";
import {
  getCollectionByHandleFirstAndAfter,
  getCollectionByHandleLastAndBefore,
  searchCollectionFirstAndAfter
} from "../../lib/resources/collections";
import {queryToParams} from "../../components/common/useFilterShopify";
import {getMenuByHandle} from "../../lib/resources/menu";
import axiosStorefrontInstance from "../../lib/axios-instances/axios-storefront-instance";
import Link from "next/link";

const OtherCollectionsNavbar = ({collections}) => {
  return (
    <div className="flex gap-5">
      { collections.map((look, index) => (
        <Link href={`/collections/${look.handle}`}>
        <span className="font-mazzard text-gray-700 cursor-pointer md:text-xl hover:font-gray-900 hover:underline">
          {look.title}
        </span>
        </Link>
      ))}
    </div>
  );
}


export default function Collections({ layout, menu }) {
  const sections = layout.sections;
  useRouterScroll();

  return (
    <Layout>
      <Head>
        <title>LENTO - collections - {layout.title}</title>
      </Head>
      <Container>
        <Block>
          <NavBar key={layout.title} menu={menu} />
        </Block>
        <Block className="container mx-auto px-4">
          <Block>
            <div className="flex items-center small-gap">
              <MainTitle title={layout.title + ' Collection'} showBackButton={false} />
            </div>
          </Block>
          <Block>
            { sections.map((section, index) => (
              <Block key={index + layout.title}>
                <DynamicSection
                  sectionKey={section.type}
                  sectionData={section}
                />
              </Block>
            ))}
          </Block>
        </Block>
      </Container>
    </Layout>
  )
}

// This gets called on every request
export async function getServerSideProps({ query } ) {
  // Fetch data from external API
  const { page, filters } = query;
  const cursor = page || null;

  let collection = {};

  const parsedFilter = filters ? queryToParams(query): [];

  if (cursor) {
    const collectionBefore = await getCollectionByHandleLastAndBefore(
      axiosStorefrontInstance, {handle: query.slug, cursor: cursor, last: 19, filters: parsedFilter}
    );

    const nProducts = 20 - (collectionBefore?.products.length || 20);

    const endCursor = collectionBefore.pageInfo.endCursor;
    collection = await getCollectionByHandleFirstAndAfter(
      axiosStorefrontInstance, {handle: query.slug, cursor: endCursor, first: nProducts, filters: parsedFilter}
    );

    collection.products = [
      ...collectionBefore.products,
      ...collection.products
    ];

    collection.pageInfo = {
      startCursor: collectionBefore.pageInfo.startCursor,
      endCursor: collection.pageInfo.endCursor,
      hasNextPage: collection.pageInfo.hasNextPage,
      hasPreviousPage: collectionBefore.pageInfo.hasPreviousPage,
    }
  } else {
    collection = await getCollectionByHandleFirstAndAfter(axiosStorefrontInstance, {
      handle: query.slug,
      cursor: cursor,
      first: 20,
      filters: parsedFilter
    });
  }

  // const otherLooks = looks.filter((c) => c?.isLook?.value === 'true' && c.handle !== params.slug);

  const layout = {
    title: collection?.title,
    sections: [{
      type: 'collection_detail',
      data: collection,
      paginationCount: 20,
    }]
  }

  return {
    props: {
      menu: await getMenuByHandle(axiosStorefrontInstance, {handle: 'main'}),
      layout: layout,
    },
  }
}
